module.exports = __webpack_public_path__ + "assets/divider.ac402121.svg";